import gql from 'graphql-tag';

export const GET_ACTIVITIES_FOR_PROGRAM_QUERY = gql`
    query GetActivitiesByFilters($filters: ActivityFiltersInput!) {
        activities: getActivitiesByFilters(filters: $filters) {
            id
            type
            subType
            programId
            memberId
            title
            description
            actions {
                actionText
                parameters
            }
            media {
                type
                url
                liveUploadLink
            }
            metadata {
                id
                name
                stageName
                previousStatusName
                currentStatusName
                userName
                userId
            }
            clientId
            createdDate
            updatedDate
        }
    }
`;
